import { updateUserLastPosition as sdkUpdateUserLastPosition } from '@deseretbook/media-sdk'
import { requestOptions } from '../base'


/**
 * Updates the user's last position for the given media.
 *
 * @example
 * updateUserLastPosition({id, sku, lastPosition: `${bookId}|${docId}|HTML|BODY|P[12]|75` })
 *   .then(success => console.log(success))
 *
 * @see https://deseretbookwiki.atlassian.net/wiki/spaces/DB/pages/33030/Deseret+Bookshelf+API+Reference#DeseretBookshelfAPIReference-Addsampleofebooktolibrary
 *
 * @param {object} params - user last position request parameters
 * @param {string} params.id - media id
 * @param {string} params.sku - product sku
 * @param {string} params.lastPosition - blr formatted string
 * @returns {Promise<object, Error>} Data from api
 * @throws {PropertyRequiredError} if required params are `null`
 */
export default function updateUserLastPosition(params = {}) {
  return sdkUpdateUserLastPosition(params, requestOptions())
}
